import { Text } from '@pbt/pbt-ui-components'

import type { MembershipPlan } from '~/types'
import { formatMembershipPeriod } from '~/utils/membershipPaymentUtils'

interface PlanPeriodCellProps {
  plan: MembershipPlan
}

const PlanPeriodCell = ({ plan }: PlanPeriodCellProps) => (
  <Text variant="body2">{formatMembershipPeriod(plan)}</Text>
)

export default PlanPeriodCell
